import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  @Input() courseDetails: any;
  @Input() purchaseCourseId: string;
  public activeIndex: number = 0;
  public ratings: any[] = [
    { label: 'Poor', value: 1 },
    { label: 'Average', value: 2 },
    { label: 'Good', value: 3 },
    { label: 'Very Good', value: 4 },
    { label: 'Excellent', value: 5 }
  ]
  public feedbackQuestions: any =
    {
      1: 'Course Content',
      2: 'Course Presentation',
      3: 'Trainer',
      4: 'Ease of Understanding',
      5: 'Duration of the course',
      6: 'Relevance of the course to the work',
      7: 'Your overall experience',
      8: 'Any specific pain points or issues',
      9: 'Comments'
    }


  public feedbackAnswers: any = {
    1: '',
    2: '',
    3: '',
    4: '',
    5: '',
    6: '',
    7: '',
    8: '',
    9: ''
  }
  constructor(private courseService: CourseService, private toastrService: ToastrService, private router: Router) { }

  ngOnInit(): void {
  }

  onClickNext() {
    this.activeIndex += 1;
  }

  onClickBack() {
    this.activeIndex -= 1;
  }

  onClickSubmit() {
    let body = {
      feedback: this.feedbackAnswers
    }
    this.courseService.updateLastPlayedCourse(this.purchaseCourseId, null, null, body).subscribe(
      (res: any) => {
        let userId = JSON.parse(sessionStorage.getItem('logged-in-user'))?._id;
        // this.router.navigate([`student/${userId}/dashboard`]);
        this.toastrService.success('Course Completed Successfully!');
      }
    )
  }

}
